<template>
  <div class="q-pa-xl centered-container-small">
    <div class="col-12">
      <span class="text-h4">{{ i18n.title }}</span>
    </div>

    <q-card class="q-pa-lg q-mt-xl">
      <q-form
        ref="profile_form"
        @submit.prevent="submit"
      >
        <div class="row q-col-gutter-md justify-start">
          <!-- First Name -->
          <div class="col-xs-12 col-sm-6">
            <span class="text-input-label">{{ i18n.first_name }}</span>
            <q-input
              v-model="form.user.first_name"
              class="full-width q-mt-sm"
              outlined
              :error="form.errors?.first_name?.length >= 1"
              :error-message="(form.errors?.first_name || [])[0]"
              :placeholder="i18n.first_name_placeholder"
              :hide-bottom-space="false"
              :hint="null"
              :rules="[(val) => val == void 0 || val?.length <= 40 || i18n.limit_max_char_40]"
            />
          </div>

          <!-- Name -->
          <div class="col-xs-12 col-sm-6">
            <span class="text-input-label">{{ i18n.last_name }}</span>
            <q-input
              v-model="form.user.last_name"
              class="full-width q-mt-sm"
              outlined
              :error="form.errors?.last_name?.length >= 1"
              :error-message="(form.errors?.last_name || [])[0]"
              :placeholder="i18n.last_name_placeholder"
              lazy-rules
              :rules="[(val) => rules_string_len(val)]"
            />
          </div>

          <!-- Email -->
          <div class="col-12">
            <span class="text-input-label">{{ i18n.email }}</span>
            <q-input
              class="full-width q-mt-sm"
              outlined
              :placeholder="form.user.email"
              lazy-rules
              disable
              :rules="[(val) => (val && val.length > 0) || i18n.required]"
            />
          </div>

          <!-- Phone -->
          <div class="col-12">
            <span class="text-input-label">{{ i18n.phone_number }}</span>
            <vue-tel-input
              v-model="form.user.phone_number"
              :error="form.errors?.phone_number?.length >= 1"
              :error-message="(form.errors?.phone_number || [])[0]"
              default-country="fr"
              :only-countries="[
                'BE', // Belgium
                'BL', // Saint Barthélemy
                'CH', // Switzerland
                'FR', // France
                'GF', // French Guiana
                'GP', // Guadeloupe
                'LU', // Luxembourg
                'MF', // Saint Martin
                'MQ', // Martinique
                'NC', // New Caledonia
                'PF', // French Polynesia
                'PM', // Saint Pierre and Miquelon
                'RE', // Réunion
                'WF', // Wallis and Futuna
                'YT' // Mayotte
              ]"
              mode="international"
              :input-options="{
                placeholder: i18n.phone_number_placeholder,
              }"
              @validate="phone_number_validation"
            />
            <span
              v-if="form_phone_number_error && form_phone_number_validation_count > 1"
              class="caption text-negative"
            >{{ form_phone_number_error }}</span>
          </div>

          <!-- Submit -->
          <div class="col-xs-12 text-right content-center">
            <q-btn
              type="submit"
              class="q-mt-md"
              :class="{ 'full-width': $q.screen.lt.sm }"
              :loading="form.processing"
              :disablelll="form.processing || form_phone_number_error != void 0"
              :label="i18n.submit"
              icon="las la-save"
              color="primary"
              unelevated
            />
          </div>
        </div>
      </q-form>
    </q-card>

    <q-card class="q-pa-lg q-mt-xl">
      <div class="row">
        <div class="col-12 text-left">
          <span class="text-input-label">{{ i18n.delete_account }}</span>

          <p class="text-caption q-mt-md">
            {{ i18n.delete_account_warning }}
          </p>
        </div>

        <div class="col-12 text-right">
          <q-btn
            class="q-mt-md"
            :class="{ 'full-width': $q.screen.lt.sm }"
            :loading="user_delete_loading"
            :label="i18n.delete_account"
            icon="las la-user-times"
            color="negative"
            unelevated
            outline
            style="text-transform: none !important"
            @click="user_delete_confirm"
          />
        </div>
      </div>
    </q-card>
  </div>
</template>
<script>
import Layout from '@/layouts/wide.vue';
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";

export default {
  components: {
    VueTelInput,
  },
  layout: Layout,
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    form_action: {
      type: String,
      required: true,
    },
    delete_action_path: {
      type: String,
      required: true,
    }
  },
  remember: 'form',
  data() {
    return {
      form_phone_number_error: null,
      form_phone_number_validation_count: 0,
      form: this.$inertia.form({
        user: {
          id: this.user.id,
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          email: this.user.email,
          phone_number: this.user.phone_number,
        },
      }),
      user_delete_loading: false,
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    submit: function () {
      this.$refs.profile_form.validate().then(success => {
        if (success && this.form_phone_number_error == void 0) {
          this.form.put(
            this.$page.props.form_action,
            {
              preserveScroll: true,
              preserveState: true,
              onError: (e) => {
                console.log(e);
                this.$q.notify({
                  message: this.$page.props.flash.alert,
                  type: "negative",
                });
              },
              onSuccess: () => {
                this.$q.notify({
                  message: this.$page.props.flash.success,
                  type: "positive",
                });
              },
            }
          );
        } else {
          this.form_phone_number_validation_count += 1;
        }
      })
    },
    user_delete_confirm: function () {
      this.$q.dialog({
        title: this.i18n.delete_account_confirm_title,
        message: this.i18n.delete_account_confirm_message,
        cancel: true,
        color: "primary",
        persistent: true,
      }).onOk(() => {
        this.user_delete();
      });
    },
    user_delete: function () {
      this.user_delete_loading = true;
      this.$rails.post(
        this.delete_action_path,
        {},
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(this.i18n.error);
          }
          return response.json();
        })
        .then((json) => {
          window.location.href = json.url;
        })
        .catch((error) => {
          console.log(error);
          this.$q.notify({
            message: error,
            multiline: true,
            type: "negative",
          });
        });
      this.user_delete_loading = false;
    },
    rules_string_len: function (string) {
      if (!string) {
        return this.i18n.required;
      } else if (string.length > 40) {
        return this.i18n.limit_max_char_40;
      } else {
        return true;
      }
    },
    phone_number_validation: function (o) {
      // o:
      // {
      //   country: ...,
      //   countryCode: ...,
      //   formatted: ...,
      //   nationalNumber: ...,
      //   possible: ...,
      //   valid: Boolean,
      // }

      // vue-tel-input validates at mount.
      // Keep track of number of validatation to avoid printing an error message on mount.
      this.form_phone_number_validation_count += 1;

      if (!o.valid) {
        this.form_phone_number_error = this.i18n.invalid_phone_number;
      } else {
        this.form_phone_number_error = null;
      }
    }
  },
};
</script>
